export const mainScripts = {
    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.stickyNavigation();
            this.offCanvas();
            this.referenceSlider();
            this.progressSlider();
            this.jobModalBox();
        });
        this.powermailTabs();
        this.AccordionTabs();
        this.lazyAnimation();
        this.parallaxImages();
        this.reloadCaptcha();
    },
    reloadCaptcha() {
        const captchaSelect = document.querySelector('#reloadCaptcha');
        if (captchaSelect) {
            const captchaHost = document.location.origin + '/index.php?&type=871';
            captchaSelect.addEventListener('click', () => {
                $.ajax({
                    url: captchaHost,
                    data: '',
                    success(result) {
                        $('#captcha-image').attr('src', result);
                    },
                });
            });
        }
    },
    stickyNavigation() {
        window.addEventListener('scroll', () => {
            const viewPort = window.innerWidth;
            if (window.scrollY > 50 && viewPort > 991) {
                document.getElementById('navbar_top').classList.add('fixed-top');
                // add padding top to show content behind navbar
                const navbarHeight = document.querySelector('.navbar').offsetHeight;
                document.body.style.paddingTop = navbarHeight + 'px';
            } else {
                document.getElementById('navbar_top').classList.remove('fixed-top');
                // remove padding top from body
                document.body.style.paddingTop = '0';
            }
        });
    },
    offCanvas() {
        const container = document.querySelector('.offcanvas-body');
        const matches = container.querySelectorAll('li.dropdown');
        for (let i = 0; i < matches.length; i++) {
            const eListener = matches[i].children[1];
            eListener.addEventListener('click', () => {
                const levelMenu = eListener.nextElementSibling;
                levelMenu.classList.toggle('open');
                eListener.classList.toggle('open');
            });
        }
    },
    AccordionTabs() {
        const allAccordions = document.querySelectorAll('.accordion-wrap');
        for (let i = 0; i < allAccordions.length; i++) {
            const accordionId = '#' + allAccordions[i].getAttribute('id');
            // Get filters
            const allFilters = [];
            const getElements = document.querySelectorAll(accordionId + ' .accordion-item button');
            for (let i = 0; i < getElements.length; i++) {
                const getElementData = getElements[i].getAttribute('data-filter');
                const check = allFilters.includes(getElementData);
                if (!check && getElementData !== '' && getElementData !== 'Alle' && getElementData !== '*') {
                    allFilters.push(getElementData);
                }
            }
            allFilters.sort();

            // Build filter tabs
            const accordionWrap = document.querySelector(accordionId);
            const accordionFilter = accordionWrap.querySelector('.accordion-filter ul');
            if (accordionWrap && accordionFilter) {
                if (allFilters.length > 0) {
                    for (let i = 0; i < allFilters.length; i++) {
                        accordionFilter.insertAdjacentHTML('beforeend', '<li><a href="#" data-filter="'
                            + allFilters[i] + '">' + allFilters[i] + '</a></li>');
                    }
                    accordionWrap.classList.add('faq');
                } else {
                    accordionFilter.remove();
                    accordionWrap.classList.remove('faq');
                }
                // Filter function
                const accordionFilterButtons = accordionFilter.querySelectorAll('a');
                if (accordionFilterButtons) {
                    for (let i = 0; i < accordionFilterButtons.length; i++) {
                        accordionFilterButtons[i].addEventListener('click', (e) => {
                            for (let i = 0; i < accordionFilterButtons.length; i++) {
                                accordionFilterButtons[i].classList.remove('active');
                            }
                            e.preventDefault();
                            const filter = accordionFilterButtons[i].getAttribute('data-filter');
                            const filterResult = accordionWrap.querySelectorAll('.accordion-item button');
                            for (let i = 0; i < filterResult.length; i++) {
                                const filterValue = filterResult[i].getAttribute('data-filter');
                                const activeItem = filterResult[i].parentNode.parentNode;
                                if (filterValue === filter || filter === '') {
                                    activeItem.classList.add('active');
                                } else {
                                    activeItem.classList.remove('active');
                                }
                            }
                            accordionFilterButtons[i].classList.add('active');
                        });
                    }
                }
            }
        }
    },
    referenceSlider() {
        const glideSelector = document.querySelector('.glide');
        if (glideSelector) {
            new Glide('.glide', {
                type: 'carousel', autoplay: 3500, perView: 5, breakpoints: { 1100: { perView: 4 }, 991: { perView: 3 }, 400: { perView: 2 } },
            }).mount();
        }
    },
    progressSlider() {
        const progressSlider = document.getElementById('progress-slider');
        if (progressSlider) {
            const sliderItem = progressSlider.querySelectorAll('.carousel-item');
            const progressBar = progressSlider.querySelector('.progress-bar');
            const totalSlides = sliderItem.length - 1;
            const progressValue = 100 / totalSlides;
            const collection = document.getElementsByClassName('progress-bar');
            progressSlider.addEventListener('slide.bs.carousel', (e) => {
                const currentCount = e.from + 1;
                let progressCount = progressValue * currentCount;
                if (currentCount > totalSlides) {
                    progressCount = 0;
                }
                progressBar.setAttribute('aria-valuenow', +Math.floor(progressCount) + '');
                collection[0].style.width = Math.floor(progressCount) + '%';
            });
        }
    },
    powermailTabs() {
        const powTabs = document.querySelectorAll('.powermail-tabs .tab');
        if (powTabs) {
            for (let i = 0; i < powTabs.length; i++) {
                const tabValue = powTabs[i].getAttribute('data-index');
                const fieldSets = document.querySelectorAll('form.powermail_form');
                for (let i = 0; i < fieldSets.length; i++) {
                    fieldSets[i].classList.add('tab-control');
                    if (fieldSets[i] === fieldSets[0]) {
                        fieldSets[i].classList.add('active');
                    }
                }
                powTabs[i].addEventListener('click', () => {
                    for (let i = 0; i < powTabs.length; i++) {
                        powTabs[i].classList.remove('active');
                    }
                    powTabs[i].classList.add('active');

                    for (let i = 0; i < fieldSets.length; i++) {
                        if ((fieldSets[i]).classList.contains(tabValue)) {
                            fieldSets[i].classList.add('active');
                        } else {
                            fieldSets[i].classList.remove('active');
                        }
                    }
                });
            }
        }

        /*
        * added Facebook Pixel lead script by Buttons(Form + powermail) click
        */
        const powsubmit = document.querySelectorAll('.powermail_submit');
        if (powsubmit) {
            Array.from(powsubmit).forEach(function (submit) {
                submit.addEventListener('click', () => {
                    fbq('track', 'Lead');
                });
            });
        }

        const anmeldungSubmit = document.querySelectorAll('button[type=submit]');
        if (anmeldungSubmit) {
            Array.from(anmeldungSubmit).forEach(function (submit) {
                submit.addEventListener('click', () => {
                    fbq('track', 'Lead');
                });
            });
        }

        // avoid double form submitting
        const className = 'form-already-submitted';
        const forms = Array.from(document.querySelectorAll('form'));
        if (!forms.length) {
            return;
        }
        forms.forEach((form) => {
            form.addEventListener('submit', (e) => {
                if (form.matches(`.${className}`)) {
                    e.preventDefault();
                    return;
                }
                form.classList.add(className);
            });
        });
    },
    jobModalBox() {
        const jobModalBox = document.querySelector('.jobs-modal');
        if (jobModalBox) {
            const jobModal = document.getElementById('job-modal-umantis');
            const initModal = new bootstrap.Modal(jobModal);
            const jobModalButton = jobModalBox.querySelector('.job-modal-umantis');
            const jobModalClose = jobModal.querySelector('.close');
            jobModalButton.addEventListener('click', () => {
                initModal.show();
            });
            jobModalClose.addEventListener('click', () => {
                initModal.hide();
            });
        }
    },
    parallaxImages() {
        const images = document.querySelectorAll('.parallax-image');
        if (images) {
            new simpleParallax(images, {
                scale: 1.2,
            });
        }
    },
    lazyAnimation() {
        const sections = document.querySelectorAll('.content .row:not(.no-animation) .frame-type-textpic:not(.frame-no-animation), '
            + '.content .row:not(.no-animation) .frame-type-text:not(.frame-no-animation), .content .row:not(.no-animation) '
            + '.frame-type-image:not(.frame-no-animation)');
        const options = {
            rootMargin: '-20%',
        };
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.intersectionRatio > 0) {
                    entry.target.classList.add('animated');
                }
            });
        }, options);
        sections.forEach(section => {
            observer.observe(section);
        });
    },
};
